import {
  FETCH_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE,
  UPDATE_PERMISSION
} from './types';
import permissionService from '../../services/PermissionService';

export const fetchPermissionsRequest = () => ({
  type: FETCH_PERMISSIONS_REQUEST
});

export const fetchPermissionsSuccess = (permissions) => ({
  type: FETCH_PERMISSIONS_SUCCESS,
  payload: permissions
});

export const fetchPermissionsFailure = (error) => ({
  type: FETCH_PERMISSIONS_FAILURE,
  payload: error
});

export const updatePermission = (permission) => ({
  type: UPDATE_PERMISSION,
  payload: permission
});

export const fetchPermissions = () => {
  return async (dispatch) => {
    dispatch(fetchPermissionsRequest());

    try {
      const permissions = await permissionService.getAllPermissions();
      dispatch(fetchPermissionsSuccess(permissions));
      return permissions;
    } catch (error) {
      const serverError = error?.message || 'Failed to fetch permissions.';
      dispatch(fetchPermissionsFailure(serverError));
      console.error('Error fetching permissions:', error);
      throw error;
    }
  };
};
